import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Note } from '../../types';
import { CountdownTimer } from '../ui';

interface HeaderProps {
  note: Note;
}

export default function Header({ note }: HeaderProps) {
  const { t } = useTranslation('viewNote');

  return (
    <div className="text-center mb-12">
      <div className="flex justify-center mb-6">
        <img src="/logo.svg" alt="Bitfortex" className="w-16 h-16" />
      </div>
      <h1 className="text-4xl font-bold mb-3 text-gray-800 tracking-tight">
        {t('title')}
      </h1>
      <p className="text-gray-600 text-lg mb-4">
        {note.encrypted 
          ? t('subtitle.protected')
          : t('subtitle.encrypted')}
      </p>
      <CountdownTimer expiresAt={note.expiresat} className="inline-flex" />
      {note.view_limit && (
        <p className="text-sm text-gray-600 mt-2">
          {t('viewCount', {
            remaining: note.view_limit - note.view_count,
            limit: note.view_limit
          })}
        </p>
      )}
    </div>
  );
}